'use client'

import { LinkReadyCard } from '../LinkReadyCard'
import { useSendJourney } from './SendJourneyContext'

/**
 * Hero collage home for the link-ready card. When the journey is active the
 * card moves to the end of the journey (DockSendSlot reveals it on arrival),
 * so it hides here to avoid telling the story out of order.
 */
export function HeroLinkReadySlot() {
  const journey = useSendJourney()
  if (journey?.enabled) return null
  return <LinkReadyCard style={{ position: 'absolute', bottom: 30, left: 40, right: 80 }} />
}
